'use client';

import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { forwardRef } from 'react';
import {
  SelectorButtonPresentation,
  SelectorButtonPresentationProps,
} from './selector-button-presentation';
import { useSelectorButtonGroupContext } from './selector-button-group-context';

type SelectorButtonGroupItemProps = Omit<ToggleGroupPrimitive.ToggleGroupItemProps, 'asChild'> &
  SelectorButtonPresentationProps;

export const SelectorButtonGroupItem = forwardRef<HTMLButtonElement, SelectorButtonGroupItemProps>(
  (
    {
      // SelectorButtonPresentation props
      children,
      icon,
      size: sizeProp,
      asChild,
      className,
      classNames,
      // ToggleGroupPrimitive.Item props
      ...props
    },
    ref,
  ) => {
    const { size: groupSize } = useSelectorButtonGroupContext();

    const size = sizeProp || groupSize;

    return (
      <ToggleGroupPrimitive.Item ref={ref} asChild {...props}>
        <SelectorButtonPresentation
          {...({
            asChild,
            icon,
            size,
            className,
            classNames,
            children,
          } as SelectorButtonPresentationProps)}
        />
      </ToggleGroupPrimitive.Item>
    );
  },
);
SelectorButtonGroupItem.displayName = 'SelectorButtonGroupItem';
